import { SEZIONI, SEZIONI_AWG } from '../constants/cableConstants';

export const EW3035_MARKING_COMPENSATION_DEFAULTS = {
    0: 0,
    1: 1.5,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
    6: 0
};

export const EW3035_ADVANCED_SETTINGS_DEFAULTS = {
    grandezzaGrassetto: 1,
    posMarcaturaTesta: 10,
    posMarcaturaCoda: 10,
    ribaltaTesta: 0,
    ribaltaCentrale: 0,
    ribaltaCoda: 1,
    loopType: 0,
    loopNum: 0,
    loopDist: 0,
    marcaturaCentrale: 'niente',
    loopMode: 'numero',
    abilitaMarcature2: false,
    tipoMarcature2: 'collegamento',
    distanzaMarcature2: 20,
    compensazioneLunghezza: true,
    forceBlackCables: false,
    reducePeelForManualMarking: true,
    compensazioneMarcaturaPerWordSize: EW3035_MARKING_COMPENSATION_DEFAULTS,
};

export const EW3035_MACHINE_SETTINGS_DEFAULTS = {
    cable_sections: {
        SEZIONI,
        SEZIONI_AWG
    },
    advanced_settings: EW3035_ADVANCED_SETTINGS_DEFAULTS
};

export const EW3035_ADVANCED_SETTING_KEYS = Object.keys(EW3035_ADVANCED_SETTINGS_DEFAULTS);

// Chiavi che dipendono dal singolo progetto: vivono in settings (salvate nel file
// del progetto) e non devono mai essere sovrascritte dalle impostazioni macchina
// globali. Vecchi record nel DB possono ancora contenerle in advanced_settings.
export const EW3035_PROJECT_SETTING_KEYS = ['marcaturePerCollegamento'];

export const omitProjectSettingKeys = (advancedSettings = {}) => {
    const result = { ...advancedSettings };
    EW3035_PROJECT_SETTING_KEYS.forEach((key) => {
        delete result[key];
    });
    return result;
};

export const getEW3035AdvancedSettings = (settings = {}) => {
    const machineAdvancedSettings = omitProjectSettingKeys(settings.machine_settings?.machines?.['EW-3035']?.advanced_settings);
    const legacyAdvancedSettings = EW3035_ADVANCED_SETTING_KEYS.reduce((result, key) => {
        if (settings[key] !== undefined) {
            result[key] = settings[key];
        }
        return result;
    }, {});

    const mergedSettings = {
        ...EW3035_ADVANCED_SETTINGS_DEFAULTS,
        ...legacyAdvancedSettings,
        ...machineAdvancedSettings
    };

    return {
        ...mergedSettings,
        compensazioneMarcaturaPerWordSize: {
            ...EW3035_MARKING_COMPENSATION_DEFAULTS,
            ...(legacyAdvancedSettings.compensazioneMarcaturaPerWordSize || {}),
            ...(machineAdvancedSettings.compensazioneMarcaturaPerWordSize || {})
        }
    };
};

export const withEW3035Settings = (settings = {}) => ({
    ...settings,
    ...getEW3035AdvancedSettings(settings)
});

export const EW3035_MACHINE = {
    id: 'EW-3035',
    name: 'EW-3035+L',
    description: 'Automatic wire cutting, stripping and laser marking machine',
    settingsSections: ['cableSections', 'advancedSettings'],
    defaultSettings: EW3035_MACHINE_SETTINGS_DEFAULTS,
    advancedSettings: EW3035_ADVANCED_SETTINGS_DEFAULTS,
    computeSections: () => []
};
